export default __webpack_public_path__ + "static/media/fr-bre.625a3644.svg";